export default __webpack_public_path__ + "static/media/cards2-black.6a2c8e38.svg";